import { render, staticRenderFns } from "./RetiradaCaixa.vue?vue&type=template&id=278b653d"
import script from "./RetiradaCaixa.vue?vue&type=script&lang=js"
export * from "./RetiradaCaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports